import React from "react";
import DynamicLayout from "../components/DynamicLayout";
import CategoryGrid from "../components/CategoryGrid";
import { useQuery } from "@apollo/client";
import { gql } from "@apollo/client";

const GET_CATEGORIES = gql`
  query CategoryQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(limit: 1000) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`;

const CategoryPage = () => {
  const { loading, error, data } = useQuery(GET_CATEGORIES);

  if (loading) return null;
  if (error) return <p>Error: {error.message}</p>;

  const { allMarkdownRemark: { group } } = data;

  return (
    <DynamicLayout>
      <section className="section has-text-centered">
        <div className="container content">
          <div className="columns">
            <div className="column">
              <h1 className="title is-size-2 has-text-primary">Categories</h1>
              <CategoryGrid categories={group} />
            </div>
          </div>
        </div>
      </section>
    </DynamicLayout>
  );
};

export default CategoryPage;
